//libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import Mask from '/react4xp/components/Mask'
import RichText from '/react4xp/components/RichText'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// prop types
export interface LinkListProps {
    title: string
    desc?: string
    links: Array<{
        text: string
        href: string
        external?: boolean
    }>
}

export default function LinkList({
    title,
    desc,
    links
}: LinkListProps) {
    return (
        <Section
            bgColor='white'
            className='link-list'
        >
            <div className='container'>
                <Mask spacing='small' bgColor='yoghurt' maskDistortion='low'>
                    <div className='row'>

                        <div className='col-lg-6 left'>

                            {isNonWhitespaceString(title) && (
                                <h2 className='h3'>
                                    {title}
                                </h2>  
                            )}

                            {isNonWhitespaceString(desc) && (
                                <RichText content={desc} />
                            )}

                        </div>

                        <div className='col-lg-6 right'>
                            { links?.map((item, i) => (
                                <a
                                    key={i}
                                    href={item.href}
                                    target={item.external ? '_blank' : undefined}
                                >
                                    
                                    <UxArrowRight />

                                    <span>
                                        {item.text}
                                    </span>

                                </a>
                            ))}
                        </div>

                    </div>
                </Mask>
            </div>
        </Section>
    )
}